import {Alert, Card, Col, Row} from "react-bootstrap";
import {Link} from "react-router";
import {DocumentationApi} from "../../api/DocumentationApi";
import {useAsync} from "../../components/useAsync";
import {ErrorAlert} from "../../components/ErrorAlert";
import {LoadingSpinner} from "../../components/LoadingSpinner";
import {PageHeader} from "../../components/PageHeader";
import {formatDate} from "../../components/format";
import {TrademarkNoticesFor} from "../../components/TrademarkNotices";
import {GLOSSARY_PATH} from "../../structuredData";
import {docs, format} from "../../i18n";

// The products that have documentation.
export function DocumentationIndexPage() {
    const {data: products, error, loading} = useAsync(() => DocumentationApi.list(), []);

    return (
        <>
            <PageHeader title={docs.title} description={docs.description}/>
            {loading && !products && <LoadingSpinner/>}
            <ErrorAlert error={error}/>
            {products?.length === 0 && <Alert variant="secondary">{docs.none}</Alert>}
            {products && (
                <Row xs={1} md={2} lg={3} className="g-4">
                    {products.map(product => (
                        <Col key={product.productId}>
                            <Card className="h-100">
                                <Card.Body>
                                    <Card.Title as="h2" className="h5">
                                        <Link to={`/docs/${encodeURIComponent(product.sku)}`} className="stretched-link">{product.productName}</Link>
                                    </Card.Title>
                                    {product.modifiedOn && <Card.Text className="small text-body-secondary">{format(docs.updated, { date: formatDate(product.modifiedOn) })}</Card.Text>}
                                </Card.Body>
                            </Card>
                        </Col>
                    ))}
                    <Col>
                        <Card className="h-100">
                            <Card.Body>
                                <Card.Title as="h2" className="h5">
                                    <Link to={GLOSSARY_PATH} className="stretched-link">{docs.glossaryCard}</Link>
                                </Card.Title>
                                <Card.Text className="small text-body-secondary">{docs.glossaryCardText}</Card.Text>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            )}
            {!!products?.length && <TrademarkNoticesFor skus={products.map(x => x.sku)} className="mt-5"/>}
        </>
    );
}
